import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from './customButton';
import { ANALYTICS_CATEGORIES } from '../constants/analytics-events';
import { ANALYTICS_EVENT_NAMES } from '../constants/analytics-events-config';
import { BUTTON_TITLES } from '../constants/button-titles';
import { useDispatch } from 'react-redux';
import { modalActions } from '../Store/modalSlice';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PAYMENTMODALUNLOCK from '../Assets/images/payment_modal_unlock.png';
import PAYMENTMODALELLIPSE from '../Assets/images/payment_modal_ellipse.png';
import CHECKCIRCLE from '../Assets/images/check-circle.png';
import { PAYMENTAMOUNT, proBenefits } from '../constants/app-constants';
import apis from '../Services/api-services';
import { fetchAgentProfileStatus } from '../Utils/helperUtils';

export default function AgentProStartFreeTrialModal({
  open,
  onClose,
  onPurchase,
}) {
  const dispatch = useDispatch();

  const [freeTrailStarted, setFreeTrailStarted] = useState(false);
  const [profileDetails, setProfileDetails] = useState(null);

  useEffect(() => {
    getProfileDetails();
  }, []);

  const getProfileDetails = async () => {
    const profile = await fetchAgentProfileStatus();

    if (!profile) {
      return;
    }
    setProfileDetails(profile);
  };

  const handleFreetrial = () => {
    apis.subscription
      .trialSubscribe()
      .then((res) => {
        dispatch(
          modalActions.openPaymentStatus({
            status: 'success',
            items: proBenefits,
            title: 'Your free trial has Started',
            subtitle: '',
          })
        );
      })
      .catch((error) => {
        dispatch(
          modalActions.openPaymentStatus({
            status: 'success',
            items: proBenefits,
            title: 'Your free trial has Started',
            subtitle: '',
          })
        );
      });
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
        <Box sx={{ position: 'relative', p: 2 }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: 'absolute', right: 8, top: 8, opacity: 0.5 }}
          >
            <CloseIcon />
          </IconButton>
          <img
            alt="unlock"
            src={PAYMENTMODALELLIPSE}
            style={{
              position: 'absolute',
              top: '5%',
              right: '50%',
              transform: 'translate(50%,-50%)',
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#600DB4',
                fontWeight: 500,
                fontSize: '20px',
                mb: '4px',
              }}
            >
              Go Agent Pro!
            </Typography>
            <Typography sx={{ color: '#1B2538', fontSize: '14px' }}>
              Be seen. Get matched. Close faster.
            </Typography>
            <img
              alt="unlock"
              src={PAYMENTMODALUNLOCK}
              style={{ width: '94px', height: '94px', marginBottom: '10px' }}
            />
            <Box
              sx={{
                padding: '12px',
                border: '1px solid  rgba(230, 218, 242, 1)',
                borderRadius: '8px',
                minWidth: '95%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  background: '#F7F0FF',
                  borderRadius: '8px',
                  padding: '12px',
                  width: '100%',
                }}
              >
                <Typography
                  sx={{
                    color: '#600DB4',
                    fontWeight: 600,
                    fontSize: '16px',
                    mb: 2,
                  }}
                >
                  What you get
                </Typography>
                {proBenefits?.map((item) => {
                  return (
                    <Box
                      sx={{
                        mb: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <img
                        src={CHECKCIRCLE}
                        alt="check"
                        style={{ width: '25px', height: '25px' }}
                      />{' '}
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: '14px',
                          color: '#1B2538',
                          ml: '4px',
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
              <Typography sx={{ color: '#600DB4', fontWeight: 500, my: 2 }}>
                Plan
              </Typography>
              <Box
                sx={{
                  background: '#F7F0FF',
                  borderRadius: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  padding: '12px',
                }}
              >
                <Typography
                  sx={{
                    color: '#600DB4',
                    fontSize: '10px',
                    fontWeight: 400,
                    textTransform: 'uppercase',
                  }}
                >
                  Recommended
                </Typography>
                <Typography sx={{ color: '#600DB4', fontWeight: 500 }}>
                  <Typography
                    component="span"
                    sx={{ fontSize: '20px', fontWeight: 500 }}
                  >
                    30 days free,{' '}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ fontSize: '16px', fontWeight: 400 }}
                  >
                    then {PAYMENTAMOUNT} / month
                  </Typography>
                </Typography>
              </Box>
              {!profileDetails?.is_owner && (
                <Typography
                  sx={{
                    color: '#996B00',
                    fontSize: '14px',
                    fontWeight: 400,
                    margin: '14px 0',
                  }}
                >
                  Contact your Organisation Admin to go Pro.
                </Typography>
              )}
              {profileDetails?.is_owner &&
                profileDetails?.verification_status !== 'Verified' && (
                  <Typography
                    sx={{
                      color: '#996B00',
                      fontSize: '14px',
                      fontWeight: 400,
                      margin: '14px 0',
                    }}
                  >
                    {' '}
                    Verify your profile to go Pro.{' '}
                  </Typography>
                )}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
              marginTop: '20px',
            }}
          >
            <CustomButton
              category={ANALYTICS_CATEGORIES.PAYMENT}
              trackEvent={ANALYTICS_EVENT_NAMES.PAYMENT_BACK}
              title={BUTTON_TITLES.BACK}
              onClick={onClose}
              type={'tertiary'}
            />
            <CustomButton
              category={ANALYTICS_CATEGORIES.PAYMENT}
              trackEvent={ANALYTICS_EVENT_NAMES.FREE_TRIAL}
              title={BUTTON_TITLES.FREE_TRIAL}
              setDisable={
                !profileDetails?.is_owner ||
                profileDetails?.verification_status !== 'Verified'
              }
              onClick={() => {
                handleFreetrial();
              }}
              type={'primary'}
            />
          </Box>
        </Box>
    </Dialog>
  );
}
